import dayjs from 'dayjs';
import { InferType } from 'yup';

import { ICaptureFactFindBeneficiary, IClientBeneficiary } from '@zeta-types';
import { nomineesValidationSchema } from './form-helpers';

type nomineesValidationSchemaType = InferType<typeof nomineesValidationSchema>;

export const mapBeneficiariesToNominees = (beneficiaries: IClientBeneficiary[]): nomineesValidationSchemaType['nominees'] => {
  return beneficiaries?.map(({ id, personalPiiDetails, relationship, percentage, addresses, dateOfBirth }) => {
    const address = addresses?.[0] || {};
    const hasPersonalPiiDetails = personalPiiDetails && Object.keys(personalPiiDetails).length > 0;

    return {
      id,
      firstName: personalPiiDetails.firstName || '',
      middleName: personalPiiDetails.middleName || '',
      lastName: personalPiiDetails.lastName || '',

      relationship: relationship || '',
      dateOfBirth: hasPersonalPiiDetails ? (personalPiiDetails.dateOfBirth ? dayjs(personalPiiDetails.dateOfBirth).toDate() : null) : dateOfBirth,
      percentage: percentage || null,
      addressId: address.id || '',
      addressLine1: address.addressLine1 || '',
      addressLine2: address.addressLine2 || '',
      city: address.city || '',
      country: address.country || '',
      postcode: address.postcode || '',
    };
  });
};

export const createFactFindBeneficiaryPayload = (nomineesData: nomineesValidationSchemaType): ICaptureFactFindBeneficiary[] => {
  return (
    nomineesData.nominees?.map((nominee) => ({
      id: nominee.id,
      percentage: nominee.percentage || 0,
      firstName: nominee?.firstName || '',
      middleName: nominee?.middleName || '',
      lastName: nominee?.lastName || '',
      relationship: nominee.relationship || '',
      dateOfBirth: dayjs(nominee.dateOfBirth).isValid() ? dayjs(nominee.dateOfBirth).format('YYYY-MM-DD') : '',
      address: [
        {
          id: nominee.addressId,
          addressLine1: nominee.addressLine1 || '',
          addressLine2: nominee.addressLine2 || '',
          city: nominee.city || '',
          country: nominee.country || '',
          postcode: nominee.postcode || '',
        },
      ],
      // addresses & personalPiiDetails is needed for AI Team APis
      addresses: [
        {
          id: nominee.addressId,
          addressLine1: nominee.addressLine1 || '',
          addressLine2: nominee.addressLine2 || '',
          city: nominee.city || '',
          country: nominee.country || '',
          postcode: nominee.postcode || '',
        },
      ],
      personalPiiDetails: {
        firstName: nominee?.firstName || '',
        middleName: nominee?.middleName || '',
        lastName: nominee?.lastName || '',
        dateOfBirth: dayjs(nominee?.dateOfBirth).isValid() ? dayjs(nominee?.dateOfBirth).format('YYYY-MM-DD') : '',
        relationship: nominee.relationship,
      },
    })) || []
  );
};
